<template>
<modal name="sign-up" height="auto" :width="480" :pivotX="0" :pivotY=".15" @before-open="assignParams">

  <aside class="window sign-up">
    <header class="window__header">
      <h1 class="window__title">Create your account</h1>
      <p class="window__description" v-if="step == 1 || step == 2 || step == 3">
        Step {{step}} of 3
      </p>
    </header>

    <section class="window__content" v-on:keyup.enter="submitStep">
      <div v-if="step === 1 && (emailTaken || checkingEmailAvailable)" style="clear:both;padding:0 0 1.5em 0;line-height: 1.5em;text-align: center;">
        <p v-if="emailTaken">Sorry, that email address has already been chosen</p>
        <p v-if="checkingEmailAvailable">Checking email address availability...</p>
      </div>
      <div class="window__input input input--flow" v-bind:class="{ 'input--success': validEmail, 'input--error': !pristine && !validEmail }" v-if="step === 1">
        <input class="input__field" type="email" placeholder="What’s your e-mail address?" v-model="email" />
      </div>
      <div class="window__input input input--flow" v-bind:class="{ 'input--success': name, 'input--error': !pristine && !name }" v-if="step === 2">
        <input class="input__field" type="text" placeholder="What’s your first and last name?" v-model="name" ref="name" />
      </div>
      <div v-if="step === 3" class="input--flow window__input">
        <p style="margin-bottom: 1em; line-height: 1.5em;">Hint: use numbers, uppercase/lowercase letters, and special characters to make a strong password.</p>
        <password v-model="password" placeholder="Choose a password" v-bind:match="null" class="window__input input--flow" ref="password" />

        <password v-model="confirmPassword" placeholder="Confirm password" v-bind:match="password" class="window__input input--flow" />
      </div>
      <div v-if="step === 'confirm'">
        <header class="window__header">
          <h1 class="window__title">Now Sign in to the account</h1>
        </header>
        <section class="window__content"  v-on:keyup.enter="submit">
          <div class="window__input input input--flow" style="margin-bottom:1em;">
            <input class="input__field" type="email" placeholder="What’s your e-mail address?" v-model="email_signin" />
          </div>

          <div class="window__input input input--flow" style="margin-bottom:1em;">
            <input class="input__field" type="password" placeholder="What's your password?" v-model="password_signin" />
          </div>

          <a href="#" v-on:click.prevent="submit" class="window__button button button--primary" v-bind:class="{ 'button--disabled': (!email_signin || !password_signin) }">
            Sign In
          </a>
        </section>
      </div>
    </section>

    <footer class="window__footer" v-if="step !== 'confirm'">
      <a href="#" class="window__button button button--primary button--large" v-bind:class="{ 'button--disabled': (step == 1 && !validEmail) || (step == 2 && !name) || (step == 3 && (!validPassword || password != confirmPassword)) }" v-on:click.prevent="submitStep" v-if="step != 'confirm'">Next</a>
      <a href="#" class="window__button button button--primary button--large" v-bind:class="{ 'button--disabled': !confirmationCode }" v-on:click.prevent="submitStep" v-if="step == 'confirm'">Confirm</a>
      <span v-on:click="hide" class="window__link link link--secondary">Cancel</span>
    </footer>
  </aside>

</modal>
</template>

<script>

import emailField from '../../lib/EmailField'
import Password from '../common/Password'
import { login, signup } from '../../lib/api/calls'
import store from '../../store'
import SignIn from "./SignIn";

let gradePassword = (password)=>{
  let score = 0;

  let grades = ['very weak', 'weak', 'ok', 'strong', 'very strong', 'very strong'];
  let colors = ['#8B0000', '#FF0000', '#CCCC00', '#83db4c', '#25a11a', '#25a11a'];

  let hasNumbers = /\d/.test(password);
  let hasLowerCase = /[a-z]/.test(password);
  let hasUpperCase = /[A-Z]/.test(password);
  let hasSpecialCharacter = /[^a-z\d]+/i.test(password);
  let hasLength = password.length >= 8;

  if(hasNumbers) ++score;
  if(hasLowerCase) ++score;
  if(hasUpperCase) ++score;
  if(hasSpecialCharacter) ++score;
  if(hasLength) ++score;

  return {
    name: grades[score],
    color: colors[score]
  }
}

let getSignUpState = ()=>{
  return {
    step: 1,
    email: '',
    name: '',
    password: '',
    confirmPassword: '',
    confirmationCode: '',
    validPassword: false,
    apiError: false,
    validEmail: false,
    emailTaken: false,
    checkingEmailAvailable: false,
    activationCode: '',
    activationCodeError: false,
    pristine: true,
    email_signin: null,
    password_signin: null
  }
}

export default {
  name: 'SignUpModal',
  mounted(){

  },
  components: {
    SignIn,
    Password
  },
  data(){
    return getSignUpState();
  },
  methods: {
    assignParams (event) {
      if (event.params && event.params.email) {
        this.email = event.params.email;
      }
    },
    hide () {
      let obj = getSignUpState()
      for(var key in obj) this[key] = obj[key];
      this.$modal.hide('sign-up')
    },
    submitStepOne(){
      if(this.validEmail){
        this.step = 2;
        this.pristine = true;

        setTimeout(function(){
          this.$refs.name.focus();
        }.bind(this), 10);
      }
    },
    submitStepTwo(){
      if(this.name){
        this.step = 3;
        this.pristine = true;

        setTimeout(function(){
          this.$refs.password.$refs.input.focus();
        }.bind(this), 10);
      }
    },
    submitStepThree(){
      if(this.validPassword && this.password == this.confirmPassword){
        signup(this.email, this.password, this.name).then(function(data){
          this.step = 'confirm';
          this.pristine = true;
          this.userId = data.id;
          /*setTimeout(function(){
            this.$refs.confirm.focus();
          }.bind(this), 100);*/
        }.bind(this));
      }
    },
    submitConfirm(){
    },
    submitStep(){
      if(this.step == 1) {
        this.submitStepOne();
      } else if(this.step == 2) {
        this.submitStepTwo();
      } else if(this.step == 3) {
        this.submitStepThree();
      } else if(this.step == 'confirm'){
        this.submitConfirm();
      }
    },
    submit () {
      let { email_signin, password_signin } = this;
      store.dispatch('login', {email: email_signin, password: password_signin});
    },
  },
  watch: {
    email: emailField,
    password: function(newVal, oldVal){
      this.pristine = false;

      let grade = gradePassword(newVal);

      this.passwordGrade = grade.name;
      this.passwordColor = grade.color;

      if(grade.name == 'very strong' || grade.name == 'strong'){
        this.validPassword = true;
      } else {
        this.validPassword = false;
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modals/SignUp.vue